<template>
  <div class="pt-3">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Анализы</a>
        </li>
      </ol>
    </nav>

    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading"/>

    <Form
      v-if="(userCanAdd || userCanEdit) && showForm"
      :test="test"
      :categories="categories"
      :healthElements="healthElements"
      v-on:cancel="closeForm"
      v-on:update-test="updateTest"
      v-on:create-test="createTest"
      v-on:delete-test="deleteTest"/>

    <div
      v-if="userCanAdd"
      class="mb-3">
      <button type="button" class="btn btn-primary " @click="showAddForm">
        Добавить новый анализ
      </button>
    </div>

    <List
      :tests="tests"
      :categories="categories"
      v-on:select-test="showUpdateForm"/>
  </div>
</template>

<script>
import Loader from './common/Loader';
import Flash from './common/Flash';
import List from './test/List';
import Form from './test/Form';

export default {
  name: 'Test',

  components: {Loader, Flash, List, Form},

  data() {
    return {
      showForm: false,
      testId: null,
      loading: false,
      error: '',
      success: '',
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    categories() {
      return this.$store.state.test.categories;
    },

    healthElements() {
      return this.$store.state.health.elements;
    },

    tests() {
      return this.$store.state.test.tests;
    },

    test() {
      return this.tests.find(t => t.id === this.testId);
    },

    userCanAdd() {
      return this.$security.voters.test.canAdd(this.$store.state.user);
    },

    userCanEdit() {
      return this.$security.voters.test.canEdit(this.$store.state.user);
    },
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        await Promise.all([
          this.$store.dispatch('TEST_LOAD_CATEGORIES'),
          this.$store.dispatch('TEST_LOAD_TESTS'),
          this.$store.dispatch('HEALTH_LOAD_ELEMENTS'),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    showUpdateForm(id) {
      this.testId = id;
      this.showForm = true;
    },

    showAddForm() {
      this.testId = null;
      this.showForm = true;
    },

    closeForm() {
      this.testId = null;
      this.showForm = false;
    },

    async deleteTest(id) {
      this.loading = true;

      try {
        this.closeForm();

        await this.$store.dispatch('TEST_DELETE_TEST', id);

        this.success = 'Анализ успешно удален';
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async updateTest(params) {
      await this.submitTest(params.id, params);
    },

    async createTest(params) {
      await this.submitTest(null, params);
    },

    async submitTest(id, params) {
      const {name, reference, measure, description, categoryId, healthId} = params;
      const data = {name, measure, reference, description, categoryId, healthId};

      this.loading = true;

      try {
        this.closeForm();

        if (id === null) {
          await this.$store.dispatch('TEST_CREATE_TEST', {data});

          this.success = 'Анализ успешно добавлен';
        } else {
          await this.$store.dispatch('TEST_UPDATE_TEST', {id, data});

          this.success = 'Анализ успешно обновлен';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
